import React from "react"
import vistaprintLogo from "./vistaprintLogo.png"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"

function Header() {
	return (
		<AppBar color="inherit" position="static">
			<Toolbar>
				<img src={vistaprintLogo} width="auto" height="25" alt=""></img>
			</Toolbar>
		</AppBar>
	)
}

export default Header
